import { ReactComponent as HomeIcon } from "../lib/icons/Home.svg";
import { ReactComponent as EnvelopeIcon } from "../lib/icons/Envelope.svg";
import { ReactComponent as PhoneIcon } from "../lib/icons/Phone.svg";

export const conInfo = [
  {
    conIcon: <HomeIcon className="h-[3.4375rem] fill-white"></HomeIcon>,
    conTitle: "Los Angeles:",
    conCap: "60 East 65th Street NY 10065",
  },
  {
    conIcon: <PhoneIcon className="h-[3.4375rem] fill-white"></PhoneIcon>,
    conTitle: "Phone:",
    conCap: "+29 (044) 593 85 63",
  },
  {
    conIcon: <EnvelopeIcon className="h-[3.4375rem] fill-white"></EnvelopeIcon>,
    conTitle: "Email Address:",
    conCap: "info@youremail.com",
  },
];
